import request from '@/utils/request'

let CertificationxApi = {

  /*实名认证列表*/
  list(data) {
    return request._post('/shop/plus.certificationx.Index/index', data);
},
/*添加实名认证*/
add(data) {
    return request._post('/shop/plus.certificationx.Index/add', data);
},
audit(data) {
    return request._post('/shop/plus.certificationx.Index/audit', data);
},
/*修改实名认证*/
edit(data) {
    return request._post('/shop/plus.certificationx.Index/edit', data);
},
/*删除实名认证*/
del(data) {
    return request._post('/shop/plus.certificationx.Index/del', data);
},
/*实名认证详情*/
detail(data) {
  return request._post('/shop/plus.certificationx.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.certificationx.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.certificationx.Setting/getSetting', data, errorback);
    },
}
export default CertificationxApi;



// WEBPACK FOOTER //
// ./src/api/certificationx.js